import axios from "axios"
import { Notification, MessageBox, Message } from "element-ui"
import store from "@/store"
import { getToken, removeToken, setToken } from "@/utils/auth"
import errorCode from "@/utils/errorCode"
import { Base64 } from 'js-base64';

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8"
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_URL,
  // 超时
  timeout: 60000,
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = config.isForm ? "application/x-www-form-urlencoded" : "application/json;charset=utf-8"

    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken && getToken() != undefined && getToken() != "undefined") {
      config.headers["Authorization"] = "Bearer " + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?"
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        var part = encodeURIComponent(propName) + "="
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]"
              var subPart = encodeURIComponent(params) + "="
              url += subPart + encodeURIComponent(value[key]) + "&"
            }
          } else {
            url += part + encodeURIComponent(value) + "&"
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    // // console.log(config, '2')
    return config
  },
  (error) => {
    // // console.log(error);
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    if (res.status == 200 && Object.prototype.toString.call(res.data) === '[object String]' && res.data.indexOf('502') > -1) {
      Message({
        message: '微服务故障，请联系管理员',
        type: "error",
      })
      return Promise.reject(new Error('微服务故障，请联系管理员'))
    } 
    // 未设置状态码则默认成功状态
    const code = res.data.code || res.status ||  200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"]

    if (code == 401) {
      if (store.getters.confirmStatus) {
        return
      }
      store.commit('CONFIRM_TRUE')
      // removeToken()
      MessageBox.confirm(
        // res.data.message,
        '请重新登录',
        "系统提示", {
        confirmButtonText: "重新登录",
        // cancelButtonText: "取消",
        type: "warning",
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
      }
      ).then(() => {
        store.dispatch("deleteCommonDataAction").then(() => {
          window.open(`${process.env.VUE_APP_DOMAINNAME}/cms/goDestAddress?url=${Base64.encode(window.location.href)}&mod=${encodeURI('金种子')}`)
        })
        // store.commit('CONFIRM_FALSE')
      })
    } else if (code == 500) {
      Message({
        message: msg,
        type: "error",
      })
      return Promise.reject(new Error(msg))
    } else if (code != 200) {
      Notification.error({
        title: msg,
      })
      return Promise.reject("error")
    } else {
      if (res.data instanceof Blob) {
        return res
      } else {
        if (res.status == 401) {
          if (store.getters.confirmStatus) {
            return
          }
          // store.commit('CONFIRM_TRUE')
          // removeToken()
          MessageBox.confirm(
            // res.data.message,
            '请重新登录',
            "系统提示", {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
          ).then(() => {
            store.dispatch("deleteCommonDataAction").then(() => {
              window.open(`${process.env.VUE_APP_DOMAINNAME}/cms/goDestAddress?url=${Base64.encode(window.location.href)}&mod=${encodeURI('金种子')}`)
            })
            // store.commit('CONFIRM_FALSE')
          })
          return
        } else if (res.status == 500) {
          Message({
            message: msg,
            type: "error",
          })
          return Promise.reject(new Error(msg))
        } else if (res.status != 200) {
          Notification.error({
            title: msg,
          })
          return Promise.reject("error")
        }
        return res.data
      }
    }
  },
  (error) => {
    let { message } = error

    if (error.response.status == 401) {
      if (store.getters.confirmStatus) {
        return
      }
      store.commit('CONFIRM_TRUE')
      // removeToken()
      MessageBox.confirm(
        // error.response.data.message,
        '请重新登录',
        "系统提示", {
        confirmButtonText: "重新登录",
        // cancelButtonText: "取消",
        type: "warning",
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
      }
      ).then(() => {
        store.dispatch("deleteCommonDataAction").then(() => {
          window.open(`${process.env.VUE_APP_DOMAINNAME}/cms/goDestAddress?url=${Base64.encode(window.location.href)}&mod=${encodeURI('金种子')}`)
        })
        // store.commit('CONFIRM_FALSE')
      })
      return Promise.reject(new Error(errorCode("401")))
    }
    if (error.response.status == 500 || 403) {
      message = error.response.data.message
    }
    if (message == "Network Error") {
      message = "后端接口连接异常"
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时"
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常"
    }
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)

export default service
